import React from 'react';
import './style.scss';
import turnThePhoneTikkiImage from '../../../images/game-tikki-2.png';
import rotateIcon from '../../../images/refresh.png';

export const TurnThePhone = () => {
  return <div className="app-turn-the-phone">
    <div className='app-turn-the-phone--tikki'><img src={turnThePhoneTikkiImage} alt=""/></div>
    
    <div className='app-turn-the-phone--container'>
    <div className="app-turn-the-phone--text">Переверни телефон <br/>вертикально</div>
    <img src={rotateIcon} alt="" className="app-turn-the-phone--rotate"/>
    </div>
    
  </div>;
}